export * from "notistack";
export { default } from "./SnackbarProvider";

export let globalEnqueueSnackbar = null;

export function setGlobalEnqueueSnackbar(enqueueFn) {
  globalEnqueueSnackbar = enqueueFn;
}
